<template>
  <div>
    <loading :loading="loading"></loading>
    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false"
      ></error-alert-item>

    <single-message-dialog
      button-text="Dismiss"
      :show="showFileNotSupportedDialog"
      message="File format not supported. Please upload PDF or image."
      @onContinue="showFileNotSupportedDialog=false"
      ></single-message-dialog>

    <confirmation-dialog
      :show="showReAttachAddressConfirmationDialog"
      :confirmation-message="getReAttachAddressConfirmationMessage"
      @onConfirm="attachAddressDocument"
      @onNotConfirm="showReAttachAddressConfirmationDialog=false"
      ></confirmation-dialog>

    <confirmation-dialog
      :show="showReAttachIdConfirmationDialog"
      :confirmation-message="getReAttachIdConfirmationMessage"
      @onConfirm="attachIdProofDocument"
      @onNotConfirm="showReAttachIdConfirmationDialog=false"
      ></confirmation-dialog>

    <k-y-c-address-document-proof-dialog
      ref="kycAddressDocumentProof"
      :show="showKYCAddressProofDialog"
      :document-types="addressDocumentTypes"
      :addressProofDocumentIdRequired="addressProofDocumentIdRequired"
      @onDialogDismiss="showKYCAddressProofDialog=false"
      @onContinue="onAddressProofAttached"
      ></k-y-c-address-document-proof-dialog>

    <k-y-c-id-document-proof-dialog
      ref="kycIdDocumentProof"
      :show="showKYCIdProofDialog"
      :document-types="idDocumentTypes"
      :idProofDocumentIdRequired="idProofDocumentIdRequired"
      @onDialogDismiss="showKYCIdProofDialog=false"
      @onContinue="onIDProofAttached"
      ></k-y-c-id-document-proof-dialog>

    <file-upload-item
      ref="fileUploadItem"
      :show-message-on-upload="false"
      @onDocumentUploaded="onDocumentUploaded($event.documentUploadResponse)"
      ></file-upload-item>


    <div>
      <div class="item-heading-desc-div margin-left-20 margin-right-20">
        <weex-text
          class="item-heading"
          v-html="getOsvInstruction"
          ></weex-text>
      </div>

      <div
        class="margin-left-20 margin-right-20"
        v-if="showSelfInstructions">
        <weex-text
          class="item-heading"
          v-html="selfAttestationInstructionHeading"
          ></weex-text>

        <instructions-item
          v-if="selfAttestationsInstructions && selfAttestationsInstructions.length"
          class="margin-top-10"
          :instructions="selfAttestationsInstructions"
          ></instructions-item>
      </div>

      <div class="margin-top-40">
        <file-attach-button
          ref="attach_id_proof"
          file-attach-button-id="attach_id_proof"
          :text="getIdProofButtonText"
          :attach-image-des-src="getIdDocumentAttachImage"
          :disabled="true"
          :disabled-button-style="disabledButtonStyle"
          @attachFilesClicked="onAttachIdClicked"
          @filesAttached="onIdFileAttached($event.files[0])"
          ></file-attach-button>
      </div>

      <hr 
        v-if="isOkycAllowed"
        style="width: 70%;"
        class="horizontal-center margin-top-30 "
      >

      <button-with-image
        class="horizontal-center margin-top-30"
        text="Attach Address Proof"
        :image-src="getAddressDocumentAttachImage"
        @onButtonClicked="onAttachAddressClicked"
        ></button-with-image>

       <div v-if="isOkycAllowed" class="margin-top-10">
          <weex-text class="item-sm-description text-color-gray">-OR-</weex-text>
          <okyc-item 
            class="horizontal-center margin-top-10"
            @okycResponse="okycResponse"
            :okycDataConfig="okycDataConfig"
          >
          </okyc-item>
        </div>
      

      <wxc-button
        text="Continue"
        class="margin-top-40 horizontal-center"
        type="blue"
        @wxcButtonClicked="onContinueClicked"
        ></wxc-button>
    </div>
  </div>

</template>

<script>
  import WxcButton from "../../../weex-ui/packages/wxc-button/index";
  import ErrorAlertItem from "./ErrorAlertItem";
  import Loading from "./Loading";
  import FileAttachButton from "./FileAttachButton";
  import ButtonWithImage from "./ButtonWithImage";
  import EzUtils from "../../utils/EzUtils";
  import { DataTables } from "../../utils/DataTables";
  import { MessageConstants } from "../../utils/MessageConstantUtil";
  import { ImageResourcesUtil } from "../../utils/ImageResourcesUtil";
  import AttributeUtil, { AttributeDetails } from "../../utils/AttributeUtil";
  import { Constants } from "../Constants";
  import DataSource from "../../data/DataSource";
  import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
  import AlertService from "../core/alert/AlertService";
  import InstructionsItem from "./InstructionsItem";
  import KYCAddressDocumentProofDialog from "../dialogs/KYCAddressDocumentProofDialog";
  import { DocumentDescription } from "../../utils/DocumentDetails";
  import SingleMessageDialog from "../dialogs/SingleMessageDialog";
  import FileUploadItem from "./FileUploadItem";
  import KYCIdDocumentProofDialog from "../dialogs/KYCIdDocumentProofDialog";
  import ConfirmationDialog from "../dialogs/ConfirmationDialog";
  import { EntityType } from "../../utils/EntityType";
  import OkycItem from "../layout/OkycItem"

  export default {
    name: 'KycOsvItem',
    components: {
      WxcButton,
      ErrorAlertItem,
      Loading,
      FileAttachButton,
      ButtonWithImage,
      InstructionsItem,
      KYCAddressDocumentProofDialog,
      KYCIdDocumentProofDialog,
      SingleMessageDialog,
      FileUploadItem,
      ConfirmationDialog,
      OkycItem
    },

    data: () => ({
      loading: false,
      errorAlertEvent: false,
      networkError: {},
      showKYCAddressProofDialog: false,
      showKYCIdProofDialog: false,
      showFileNotSupportedDialog: false,
      showReAttachAddressConfirmationDialog: false,
      showReAttachIdConfirmationDialog: false,
      attachedDocuments: {},
      idProofAttached: false,
      addressProofAttached: false,
      currentlyUploadingFileKey: null,
      currentlyUploadingEKycDataKey: null,
      addressProofDocumentIdRequired: true,
      idProofDocumentIdRequired: true,
      isOkycCompleted: false,
      isOkycAllowed: false,
    }),
    props: {
      kycOsvDetailsConfig: {
        type: Object,
        required: true,
        default: () => ({})
      },
      okycDataConfig: {
        type: Object,
        required: true,
        default: () => ({})
      },
      isRetailerKycConfig: {
        type: Boolean,
        required: false,
        default: () => false
      }
    },

    created(){
      this.addressProofDocumentIdRequired = this.kycOsvDetailsConfig.addressProofDocumentIdentifierRequired;
      this.idProofDocumentIdRequired = this.kycOsvDetailsConfig.idProofDocumentIdentifierRequired;
      if(Object.keys(this.okycDataConfig).length != 0 && this.okycDataConfig.constructor === Object){
        this.isOkycAllowed = true;
      }
    },

    methods: {
      showToast(message) {
        AlertService.showToast(message);
      },

      showError(error) {
        this.loading = false;
        this.networkError = error;
        this.errorAlertEvent = true;
      },

      onAttachAddressClicked() {
        if (this.addressProofAttached) {
          this.showReAttachAddressConfirmationDialog = true;
        } else {
          this.attachAddressDocument();
        }
      },

      attachAddressDocument() {
        this.showReAttachAddressConfirmationDialog = false;
        this.addressProofAttached = false;
        this.removeAttachedAddressProofs();
        this.$refs.kycAddressDocumentProof.showKYCAddressProofOptions();
        this.showKYCAddressProofDialog = true;
      },

      onAddressProofAttached(addressProofDetails) {
        this.showKYCAddressProofDialog = false;
        this.addressProofAttached = true;
        this.attachedDocuments = { ...this.attachedDocuments, ...addressProofDetails }
      },

      onAttachIdClicked() {
        if (this.idProofAttached) {
          this.showReAttachIdConfirmationDialog = true;
        } else {
          this.attachIdProofDocument();
        }
      },

      attachIdProofDocument() {
        this.showReAttachIdConfirmationDialog = false;
        if (this.isIdProofSingle) {
          this.$refs.attach_id_proof.attachFile();
        } else {
          this.removeAttachedIdProofs();
          this.idProofAttached = false;
          this.$refs.kycIdDocumentProof.showKYCIdProofOptions();
          this.showKYCIdProofDialog = true;
        }
      },

      onIDProofAttached(ifProofDetails) {
        this.showKYCIdProofDialog = false;
        this.idProofAttached = true;
        this.attachedDocuments = { ...this.attachedDocuments, ...ifProofDetails };
      },

      onIdFileAttached(file) {
        if (EzUtils.isFileAllowedToUpload(file)) {
          const attachedDocuments = {};
          const documentDetails = DocumentDescription.KYC_OSV_ID_PROOF;
          attachedDocuments[Constants.DOCUMENT_PURPOSE_ID + "_" + documentDetails.name] = {
            uri: file,
            documentName: documentDetails.name,
            documentDescription: documentDetails.description,
            documentDirectory: documentDetails.directory,
            documentCategory: Constants.DOCUMENT_PURPOSE_ID,
            documentType: this.idDocumentTypes[0]
          };
          this.onIDProofAttached(attachedDocuments);
        } else {
          this.showFileNotSupportedDialog = true;
        }
      },

      onContinueClicked() {
        if (this.checkForValidation()) {
          this.uploadRemainingDocumentsOrSaveEKycData();
        }
      },

      checkForValidation() {
        if (!this.idProofAttached) {
          this.showToast(MessageConstants.UPLOAD_DOCUMENT + " " + this.getIdProofName);
          return false;
        }

        if (!this.addressProofAttached) {
          if(this.isOkycAllowed && this.isOkycCompleted){
              return true;
          }else{
            let errorToast = MessageConstants.UPLOAD_DOCUMENT + " Address Proof";
            errorToast = this.isOkycAllowed ? errorToast+ " or complete Offline KYC" : errorToast;
            this.showToast(errorToast);
            return false;
          }
        }

        return true;
      },

      uploadRemainingDocumentsOrSaveEKycData() {
        let currentlyUploadingFileKey = null;
        let currentlyUploadingFileDetails = null;
        for (const [key, details] of Object.entries(this.attachedDocuments)) {
          if (details && !details.documentUploaded) {
            currentlyUploadingFileKey = key;
            currentlyUploadingFileDetails = details;
            break;
          }
        }
        if (currentlyUploadingFileDetails) {
          this.currentlyUploadingFileKey = currentlyUploadingFileKey;
          this.$refs.fileUploadItem.createDocument(
            EntityType.CLIENTS,
            LoanScopeDataHolder.getClientId(),
            currentlyUploadingFileDetails.documentName,
            currentlyUploadingFileDetails.documentDescription,
            currentlyUploadingFileDetails.documentDirectory,
            currentlyUploadingFileDetails.uri
          );
        } else {
          this.uploadRemainingEKycDataOrInsertAddressSkipAttribute();
        }
      },

      uploadRemainingEKycDataOrInsertAddressSkipAttribute() {
        let currentlyUploadingEKycDataKey = null;
        let currentlyUploadingEKycDetails = null;
        for (const [key, details] of Object.entries(this.attachedDocuments)) {
          if (details && !details.additionalDetailsUploaded) {
            currentlyUploadingEKycDataKey = key;
            currentlyUploadingEKycDetails = details;
            break;
          }
        }
        if (currentlyUploadingEKycDetails) {
          this.currentlyUploadingEKycDataKey = currentlyUploadingEKycDataKey;
          this.uploadEKycData(
            currentlyUploadingEKycDetails.documentCategory,
            currentlyUploadingEKycDetails.documentType,
            currentlyUploadingEKycDetails.uploadedFileDetails.resourceId,
            currentlyUploadingEKycDetails.documentDescription,
            currentlyUploadingEKycDetails.documentProofNumber
          );
        } else {
          if(!this.isRetailerKycConfig) {
            this.insertAddressBackPageSkippedAttribute();
          } else {
            this.$emit("osvCompleted");
          }
        }
      },

      uploadEKycData(documentCategory, documentType, documentId,documentDescription,identifier) {
        this.loading = true;
        let payLoad = {
            source: this.getKycSource,
            kyc_mode: "IMAGE",
            document_purpose: documentCategory,
            document_type: documentType,
            document_id: documentId,
          }
        if(!this.isRetailerKycConfig) {
          payLoad.kyc_status = "COMPLETED";
        }
        DataSource.addDataTableEntry(
          DataTables.EKYC_DATA,
          LoanScopeDataHolder.getClientId(),
          payLoad
        )
          .then(eKycDataRes => {
            this.loading = false;
            if (eKycDataRes.errorOccurred) {
              this.showError(eKycDataRes.data)
            } else {
              if (this.currentlyUploadingEKycDataKey
                && this.attachedDocuments[this.currentlyUploadingEKycDataKey]
              ) {
                const fileDetails = this.attachedDocuments[this.currentlyUploadingEKycDataKey];
                fileDetails.additionalDetailsUploaded = true;
                this.attachedDocuments[this.currentlyUploadingEKycDataKey] = fileDetails;
              }

              if(identifier){
                let identifiersArray = [];
                let identifiersObj = {};
                identifiersObj.identifierType = documentType;
                identifiersObj.identifierId = identifier;
                identifiersArray.push(identifiersObj);
                DataSource.createClientIdentifierUsingCreditEngine(LoanScopeDataHolder.getClientId(),identifiersArray)
                .then(clientIdentifierRes => {
                  if (clientIdentifierRes.errorOccurred) {
                    this.showError(clientIdentifierRes.data)
                  }else{
                    this.uploadRemainingEKycDataOrInsertAddressSkipAttribute();
                  }
                });
              }else{
                this.uploadRemainingEKycDataOrInsertAddressSkipAttribute();
              }

            }
          })
      },


      insertAddressBackPageSkippedAttribute() {
        this.loading = true;
        const addressBackPageSkipped = this.attachedDocuments[Constants.DOCUMENT_PURPOSE_ADDRESS
        + "_" + DocumentDescription.KYC_OSV_ADDRESS_PROOF_BACK.name]
          ? false
          : true;
        DataSource.createOrUpdateAttribute(AttributeUtil.getAttributeUpdateDto(
          EntityType.LOANS,
          LoanScopeDataHolder.getLoanId(),
          AttributeUtil.getSingleAttributeData(
            AttributeDetails.ADDRESS_PROOF_BACK_DOCUMENT_SKIPPED.key,
            AttributeDetails.ADDRESS_PROOF_BACK_DOCUMENT_SKIPPED.name,
            addressBackPageSkipped.toString()
          )
        ))
          .then(skipAttributeRes => {
            this.loading = false;
            if (skipAttributeRes.errorOccurred) {
              this.showError(skipAttributeRes.data);
            } else {
              this.$emit("osvCompleted");
            }
          })
      },

      onDocumentUploaded(uploadedFileDetails) {
        if (this.currentlyUploadingFileKey
          && this.attachedDocuments[this.currentlyUploadingFileKey]
        ) {
          const fileDetails = this.attachedDocuments[this.currentlyUploadingFileKey];
          fileDetails.documentUploaded = true;
          fileDetails.uploadedFileDetails = uploadedFileDetails;
          this.attachedDocuments[this.currentlyUploadingFileKey] = fileDetails;
        }
        this.uploadRemainingDocumentsOrSaveEKycData();
      },

      removeAttachedIdProofs() {
        this.removeAttachedProofs(Constants.DOCUMENT_PURPOSE_ID + "_");
      },

      removeAttachedAddressProofs() {
        this.removeAttachedProofs(Constants.DOCUMENT_PURPOSE_ADDRESS + "_");
      },

      removeAttachedProofs(documentPrefix) {
        const attachedDocumentsKeys = Object.keys(this.attachedDocuments);
        attachedDocumentsKeys && attachedDocumentsKeys.forEach(attachedDocumentKey => {
          if (attachedDocumentKey && attachedDocumentKey.startsWith(documentPrefix)) {
            delete this.attachedDocuments[attachedDocumentKey];
          }
        });
      },

      okycResponse(okycResponse){
        this.isOkycCompleted = okycResponse['success'];
      }
    },

    computed: {
      addressDocumentTypes() {
        return this.kycOsvDetailsConfig && this.kycOsvDetailsConfig.allowedAddressProofs
          ? this.kycOsvDetailsConfig.allowedAddressProofs
          : [];
      },

      idDocumentTypes() {
        return this.kycOsvDetailsConfig && this.kycOsvDetailsConfig.allowedIdProofs
          ? this.kycOsvDetailsConfig.allowedIdProofs
          : [];
      },

      isIdProofSingle() {
        return this.idDocumentTypes.length === 1;
      },

      getIdProofName() {
        let idProofName = "Identity Proof";
        if (this.isIdProofSingle) {
          idProofName = EzUtils.removeUnderscoreFromString(
            this.idDocumentTypes[0],
            ["PAN", "ID"]
          );
        }

        return idProofName;
      },

      getIdProofButtonText() {
        return `Attach ${this.getIdProofName}`;
      },

      getOsvInstruction() {
        return this.kycOsvDetailsConfig ? this.kycOsvDetailsConfig.osvInstruction : "";
      },

      showSelfInstructions() {
        return this.kycOsvDetailsConfig ? this.kycOsvDetailsConfig.showSelfInstructions : false;
      },

      selfAttestationInstructionHeading() {
        return this.kycOsvDetailsConfig ? this.kycOsvDetailsConfig.selfInstructionHeading : "";
      },

      selfAttestationsInstructions() {
        return this.kycOsvDetailsConfig && this.kycOsvDetailsConfig.selfInstructions
          ? this.kycOsvDetailsConfig.selfInstructions
          : [];
      },

      getKycSource() {
        return this.kycOsvDetailsConfig ? this.kycOsvDetailsConfig.source : "";
      },

      getReAttachAddressConfirmationMessage() {
        return `Do you want to reupload <b>Address proof</b>? <br>If yes, previous uploaded <b>Address proof</b> will be deleted.`
      },

      getReAttachIdConfirmationMessage() {
        return `Do you want to reupload <b>${this.getIdProofName}</b>? <br>If yes, previous uploaded <b>${this.getIdProofName}</b> will be deleted.`
      },

      getIdDocumentAttachImage() {
        if (this.idProofAttached) {
          return ImageResourcesUtil.getImageLink(ImageResourcesUtil.TICK_GREEN)
        } else {
          return ImageResourcesUtil.getImageLink(ImageResourcesUtil.CAMERA_ADD)
        }
      },

      getAddressDocumentAttachImage() {
        if (this.addressProofAttached) {
          return ImageResourcesUtil.getImageLink(ImageResourcesUtil.TICK_GREEN)
        } else {
          return ImageResourcesUtil.getImageLink(ImageResourcesUtil.CAMERA_ADD)
        }
      },

      disabledButtonStyle() {
        return {
          backgroundColor: "#ffffff",
          "border-width": "1px",
          "border-color": "gray",
          "border-style": "solid"
        };
      }
    }
  }
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>

<style scoped>

</style>
